import { Icon } from "@nykaa/payment-ui/src/Icon";
import { Text } from "@nykaa/payment-ui/src/Text";
import { TextButton } from "@nykaa/payment-ui/src/Button";
import { getPlatform } from "../../helpers";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import React from "react";
import { RetryWalletLayout, RetryWalletWrapper } from "./assets/style";


export interface RetryWalletTileProps {
    nykaaWalletTitle: string;
    handleRetryWalletClick: () => {};
    unableToFetchWalletText: string;
    retryButtonText: string;
    theme: Theme;
  }
export const RetryWalletTile = (props: RetryWalletTileProps) => {
    const {
        nykaaWalletTitle,
        theme,
        unableToFetchWalletText,
        retryButtonText,
        handleRetryWalletClick,
      } = props;
    const platform = getPlatform();

    return (
      <RetryWalletWrapper className="layout vertical mt20 prl20 payment-view">
        <h3 className="font-size-16 mb8 lh-24 font-semibold">{nykaaWalletTitle}</h3>
        <RetryWalletLayout theme={theme} className="layout prl16 ptb12">
          <div className="retry-heading">
            <Icon icon={getIcons(platform, ICONS_NAMES.ALERT)} />
            <Text
                        text={unableToFetchWalletText}
                        color={theme.colors.negative}
                        font={theme.typography.bodySmall}
                        theme={theme}
                    />
          </div>
          <TextButton
                    text={retryButtonText}
                    font={theme?.typography.buttonMedium}
                    color={theme?.colors.primary}
                    onClick={handleRetryWalletClick}
                />
        </RetryWalletLayout>
      </RetryWalletWrapper>
    );
};
